import React, { Fragment, useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import funnel from 'highcharts/modules/funnel';

funnel(Highcharts);

const FunnelChart = (props) => {
    let { dashboard, data } = props;
    let dashboardType = parseInt(dashboard[2]);
    let dashboardName = dashboard[1];
    let funnelchartdata = [];
    for (let i = 0; i < data[2].length; i++) {
        let paramstr = {name: data[2][i][0]+":  "+parseInt(data[2][i][1], 10).toLocaleString()+"  ",y: parseInt(data[2][i][1], 10)};
        funnelchartdata.push(paramstr);
    }
    let options = {
	    chart: {
	        type: 'funnel'
	    },
	    title: {
	        text: ""
	    },
	    tooltip: {
	    	  pointFormat: ' '
        },
	    plotOptions: {
	        series: {
	            dataLabels: {
	                enabled: false,
	                softConnector: true
	            },
	            center: ['50%', '50%'],
	            neckWidth: '30%',
	            neckHeight: '25%',
	            width: '80%'
	        }
	    },
	    legend: {
	        enabled: false
	    },
	    credits:{
	    	enabled: false
	    },
	    series: [{
	       // name: that.dsdetails.getName(),
	        data: funnelchartdata
	    }]
	}
    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
};

export default FunnelChart;